import { Grid } from '../../../../../app/core/components/grid/grid.model';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('requisitionToConsignment', {
        templateUrl: 'views/components/views/requisitionToConsignment/requisitionToConsignment.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$q', 'stateService', 'utilityService', 'requisitionToConsignmentService', function ($stateParams, $q, stateService, utilityService, requisitionToConsignmentService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockPlaceIdFrom = $stateParams.stockplace_id_from;
            let stockPlaceIdTo = $stateParams.stockplace_id_to;
            let consignmentKeyno = $stateParams.consignment_keyno;

            vm.model = {
                setting: {},
                lockedCreate: false
            };

            vm.grid = null;

            // #endregion VARIABLES & DEFINITIONS

            function readGrid() {
                if (vm.grid === null) {
                    vm.grid = new Grid()
                        .setRememberId('w_requisitiontoconsignment.grid')
                        .setLoadDataFunction({ method: 4024, parameters: () => vm.model.setting })
                        .addToolbarButton({
                            name: 'requisitiontoconsignment_create',
                            text: 'requisitiontoconsignment_create',
                            translate: true,
                            icon: 'fas fa-arrow-to-bottom',
                            cssClass: 'tt-button tt-button--success im-grid-btn-xs-l',
                            func: async () => {
                                const mergeObj = { ...vm.model.setting, records: vm.grid.gridfunc.getIsSelectedRows() };
                                const response = await requisitionToConsignmentService.createRequisitionToConsignments(mergeObj);

                                stateService.go(response[0].webpagename, { consignment_keyno: response[0].consignment_keyno });
                            },
                            disabled: () => {
                                return vm.grid.gridfunc.getIsSelectedRows().length === 0 || vm.grid.gridfunc.getIsSelectedRows().some((row) => [0, '0', false, 'false'].includes(row.can_deliver));
                            }
                        })
                } else {
                    vm.grid.gridfunc?.read();
                }
            }

            // #region LOAD PROCEDURE FUNCTION CALLS

            let loadSetting = function () {
                const deferred = $q.defer();

                requisitionToConsignmentService.getSetting({
                    stockplace_id_from: stockPlaceIdFrom,
                    stockplace_id_to: stockPlaceIdTo,
                    consignment_keyno: consignmentKeyno
                }).then(function (info) {
                    angular.copy(info[0], vm.model.setting);
                    readGrid();

                    deferred.resolve();
                });

                return deferred.promise;
            };

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
